import React from 'react';
import { getFormData } from '../../common';
import { EverestAdminRepository } from '../../repository';
import { NavigationBar } from './NavigationBar';

class LeagueDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      leagueId: props.match.params.leagueId,
      league: {},
      allMountainPeaks: [],
      mountainPeakIds: []
    };

    this.everestRepository = new EverestAdminRepository();
  }

  componentDidMount() {
    const leagueId = this.state.leagueId;
    this.everestRepository.findLeague({ leagueId }, (data) => {
      this.setState({ league: data });
    });
    this.everestRepository.searchMountainPeak({}, (data) => {
      this.setState({ allMountainPeaks: data.content });
    });
    this.everestRepository.searchLeagueForMountainPeak({ leagueId }, (data) => {
      this.setState({ mountainPeakIds: data.content.map(v => v.mountainPeakId) });
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const formData = getFormData(e.target);
    this.everestRepository.updateLeague(formData, () => {
      window.Toast.info("Completed!");
    });
  }

  onClickDelete(e) {
    e.preventDefault();
    const confirm = window.confirm("Are you sure?");
    if (confirm) {
      const leagueId = this.state.leagueId;
      this.everestRepository.deleteLeague({ leagueId }, () => {
        window.Toast.info("Completed!");
        window.history.back();
      });
    }
  }

  onClickMountainPeak(e) {
    e.preventDefault();
    const target = e.currentTarget;
    const mountainPeakId = window.Number(target.dataset.peakid);

    const include = this.state.mountainPeakIds.includes(mountainPeakId);
    if (include) {
      const mountainPeakIds = this.state.mountainPeakIds.filter(id => id !== mountainPeakId);
      this.setState({ mountainPeakIds });
      return;
    }

    const mountainPeakIds = this.state.mountainPeakIds;
    mountainPeakIds.push(mountainPeakId);
    this.setState({ mountainPeakIds });
  }

  onClickApply(e) {
    e.preventDefault();
    this.everestRepository.updateLeagueForMountainPeak({
      leagueId: this.state.leagueId,
      mountainPeakIds: this.state.mountainPeakIds
    }, () => {
      window.Toast.info("Completed!");
    });
  }

  render() {
    return (
      <React.Fragment>
        <NavigationBar />

        <br />
        <div className={"container"}>
          <form className={"form-text-align-default"} onSubmit={this.onSubmit.bind(this)}>
            <input name={"leagueId"} type={"hidden"} defaultValue={this.state.leagueId}></input>
            <div className={"form-group"}>
              <label>leagueName</label>
              <input name={"name"} className={"form-control"} type={"text"} defaultValue={this.state.league.name}></input>
            </div>

            {this.state.league.id !== undefined && (
              <>
                {!this.state.league.deleted && (
                  <div className={"form-group"}>
                    <button className={"btn btn-primary"} type={"submit"}>수정</button>&nbsp;
                    <button className={"btn btn-danger"} onClick={this.onClickDelete.bind(this)}>삭제</button>
                  </div>
                )}
                {this.state.league.deleted && (
                  <p style={{ color: "#f00" }}>삭제 완료</p>
                )}
              </>
            )}
          </form>
        </div>

        <br />
        <div className={"container"} style={{ textAlign: "initial" }}>
          <div style={{ padding: "10px 0" }}>
            {this.state.allMountainPeaks.map((item) => (
              <a href={"/"} key={item.id}
                data-peakid={item.id}
                onClick={this.onClickMountainPeak.bind(this)}
                className={`badge ${this.state.mountainPeakIds.includes(item.id) ? "badge-primary" : "badge-secondary"}`}
                style={{ margin: 2 }}>
                {item.mountainName} {item.peakName}
              </a>
            ))}
            <div>
              <br />
              {this.state.league.id !== undefined && (
                <>
                  {!this.state.league.deleted && (
                    <button className={"btn btn-primary btn-sm"} onClick={this.onClickApply.bind(this)}>적용</button>
                  )}
                  {this.state.league.deleted && (
                    <p style={{ color: "#f00" }}>삭제 완료</p>
                  )}
                </>
              )}

            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export { LeagueDetail };
